module.exports = __webpack_public_path__ + "img/banner-13.04939c53.jpg";